import { useGraphqlMutation } from "@mzara/component";

export const useSaveFormationChapterMutation = () => {
    return useGraphqlMutation(gql);
};

const gql = `
    mutation saveFormationChapterMutation($data: JSONObject) {
        saveFormationChapter(data: { data: $data }) {
            id
        }
    }
`;
